// extracted by mini-css-extract-plugin
module.exports = {"modal":"styles_modal__19DoR","content":"styles_content__1s_4Y"};